import { api } from '../../utils/api';
export interface FileUploadDTO {
  id: number | null;
  error: string | null;
}

export const uploadProfilePicture = (body: FormData) => api<FileUploadDTO[]>('POST', `upload/ProfilePhoto`, {}, null, body);

export const uploadFile = (body: FormData) => api<FileUploadDTO[]>('POST', `upload`, {}, null, body);
